<template>
    <div>
        <div class="white_bg">

            <div class="l-row">
                <div class="l-title">
                    <div class="l-block"></div>对比车型
                </div>
                <div class="model-list">
                    <div class="model-item" v-for="item in modelList" :key="item.id">
                        <div class="model-name">{{ item.brand.name }} {{ item.name }}</div>
                        <div class="delete-btn" @click="handleDeleteClick(item)"></div>
                    </div>
                </div>
            </div>

            <div class="l-row">
                <div class="l-title">
                    <div class="l-block"></div>筛选时间
                </div>
                <el-config-provider :locale="zhCn">
                    <div class="time-select">
                        <div class="date-text">开始时间</div>
                        <el-date-picker v-model="tempStartMonth" type="month" placeholder="年/月" :prefix-icon="null"
                            :clear-icon="null" format="YYYY-MM" value-format="YYYY-MM" :disabled-date="disabledStartDate">
                        </el-date-picker>
                        <div class="date-line"></div>
                        <div class="date-text" style="margin-left: 90px;">结束时间</div>
                        <el-date-picker v-model="tempEndMonth" type="month" placeholder="年/月" :prefix-icon="null"
                            :clear-icon="null" format="YYYY-MM" value-format="YYYY-MM" :disabled-date="disabledEndDate">
                        </el-date-picker>
                        <div @click="search" class="date-btn">筛选</div>
                    </div>
                </el-config-provider>
            </div>

            <div class="fg-line"></div>

            <v-chart class="chart" :option="function0Option" style="width:100%;height: 400px;"
                @click="onFunction0ChartClick" />

            <div v-if="step >= 1">
                <div class="c-title">
                    <div class="c-title-text">{{ currentFunction0.name }}</div>
                    <div class="c-title-line"></div>
                </div>
                <v-chart class="chart" :option="function1Option" style="width:100%;height: 400px;"
                    @click="onFunction1ChartClick" />
            </div>


            <div v-if="step >= 2">
                <div class="c-title">
                    <div class="c-title-text">{{ currentFunction0.name }}-{{ currentFunction1.name }}</div>
                    <div class="c-title-line"></div>
                </div>
                <v-chart class="chart" :option="function2Option" style="width:100%;height: 400px;"
                    @click="onFunction2ChartClick" />
            </div>


            <table class="model-table" v-if="step >= 3">
                <thead>
                    <tr>
                        <th v-for="item in modelList" :key="item.id" :style="{ width: columnWidth }">
                            {{ item.brand.name }} {{ item.name }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="i in detailData.max_length" :key="i">
                        <td v-for="(model, modelIndex) in modelList" :key="model" :style="{ width: columnWidth }">
                            <div v-if="detailData['list'][modelIndex][i - 1]">
                                <div style="font-weight: bold;">{{ detailData['list'][modelIndex][i - 1]['intro'] }} （{{
                                    detailData['list'][modelIndex][i - 1]['published'] }}）</div>
                                <div class="like-btn-list">
                                    <div class="like-btn" @click="searchLike(detailData['list'][modelIndex][i - 1], 1)">
                                        ota内容对比信息搜索</div>
                                    <div v-if="detailData['list'][modelIndex][i - 1]['item'] != '创新项' && detailData['list'][modelIndex][i - 1]['item'] != '智驾'"
                                        class="like-btn" @click="searchLike(detailData['list'][modelIndex][i - 1], 2)">
                                        车型评测对比信息搜索</div>
                                    <div v-if="detailData['list'][modelIndex][i - 1]['item'] == '创新项'" class="like-btn"
                                        @click="searchLike(detailData['list'][modelIndex][i - 1], 3)">
                                        车型评测对比信息搜索</div>
                                </div>
                                <div style="margin-top: 10px;margin-bottom: 10px;">{{ detailData['list'][modelIndex][i -
                                    1]['content'] }}</div>
                                <div><el-image v-for="img in detailData['list'][modelIndex][i - 1]['attachment']"
                                        class="detail-img" :src="img.link_url" :key="img.id"
                                        :preview-src-list="[img.link_url]" fit="cover" /></div>

                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- 自定义对话框 -->
    <div v-if="dialogVisible" class="custom-dialog-mask" @click="closeDialog">
        <div class="custom-dialog" @click.stop>
            <div v-if="searchType == 1">
                <div class="custom-dialog-header">
                    <span>ota内容对比信息搜索</span>
                    <button class="close-button" @click="closeDialog">×</button>
                </div>
                <div class="custom-dialog-content">
                    <!-- 对话框内容 -->
                    <div class="mt-10 detail-list">
                        <div class="detail-item" v-for="(item, index) in keywordDetail" :key="item.id">
                            <div class="detail-item-title">{{ index + 1 }}.{{ item.intro }}</div>
                            <div class="detail-content">{{ item.content }}</div>
                            <div class="detail-item-main">
                                <template v-for="img in item.attachment" :key="img.id">
                                    <el-image v-if="img.type === 1" class="detail-img" :src="img.link_url"
                                        :preview-src-list="[img.link_url]" fit="cover" />
                                    <div v-else-if="img.type === 2" class="detail-video-wrapper" @click.stop="previewVideo(item.attachment.filter(a => a.type === 2))">
                                        <div class="detail-video-thumb">
                                            <video controlsList="nodownload" :src="img.link_url"
                                                :poster="img.link_url + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                                                preload="none"></video>
                                        </div>
                                        <div class="look_pic">点击查看视频</div>
                                    </div>
                                </template>
                            </div>
                            <div class="detail-item-model">
                                <div>{{ item.brand.name }}&nbsp;&nbsp;|&nbsp;&nbsp; {{ item.model }}</div>
                                <div class="detail-item-model-date">{{ item.published }}</div>
                            </div>
                            <div class="sp-line"></div>
                        </div>
                    </div>
                </div>

            </div>




            <div v-if="searchType == 2">
                <div class="custom-dialog-header">
                    <span>车型评测对比信息搜索</span>
                    <button class="close-button" @click="closeDialog">×</button>
                </div>
                <div class="custom-dialog-content">
                    <el-table v-if="node_list" empty-text="没有匹配的相关项目节点" v-loading="loading" :data="node_list"
                        row-key="id" border>
                        <el-table-column :resizable="false" label="测评项" width=420>
                            <template #default="scope">
                                <div class="node_name">
                                    {{ scope.row.name }}
                                </div>
                                <div class="path_names">( <template v-for="(item, ind) in scope.row.path_node"
                                        :key="ind">
                                        <span v-if="ind > 0">></span><span>{{ item.node_name }}</span>
                                    </template> )
                                </div>
                                <div></div>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="得分" min-width=300>
                            <template #default="scope">
                                <el-checkbox-group v-model="scope.row.checked_list" :max="3">
                                    <div class="model_list flex">
                                        <el-checkbox class="model_name" v-for="item in scope.row.model_list"
                                            :key="item.model_id" :label="item">
                                            {{ item.short_name }}({{ item.score }}分)
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="操作" width=80>
                            <template #default="scope">
                                <div class="contrast_btn" @click="contrastFn(scope.row); showRuleDesc = false;">对比</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div v-if="searchType == 3">
                <div class="custom-dialog-header">
                    <span>车型评测对比信息搜索</span>
                    <button class="close-button" @click="closeDialog">×</button>
                </div>
                <div class="custom-dialog-content">
                    <el-table v-if="node_list2" empty-text="没有匹配的相关项目节点" v-loading="loading" :data="node_list2"
                        row-key="id" border :span-method="objectSpanMethod">
                        <el-table-column :resizable="false" label="测评项" width=420>
                            <template #default="scope">
                                <div class="node_name">
                                    {{ scope.row.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="得分" min-width=300>
                            <template #default="scope">
                                <el-checkbox-group v-model="scope.row.checked_list" :max="3">
                                    <div class="model_list flex">
                                        <el-checkbox class="model_name" v-for="item in scope.row.model_list"
                                            :key="item.model_id" :label="item">
                                            {{ item.short_name }}({{ item.score }}分)
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="操作" width=80>
                            <template #default="scope">
                                <div class="contrast_btn" @click="contrastFn2(scope.row); showRuleDesc = false;">对比
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>

    <el-drawer v-model="dialogCompareVisible" :title="node_name" direction="rtl" :before-close="handleClose"
        :size="'auto'" modal-class="modal_transparent">
        <div class="my_dialog" v-if="dialogCompareVisible">
            <table class="detail_table" border="1">
                <tr class="detail_title">
                    <td class="detail_attr">车型</td>
                    <template v-for="(item, ind) in model_list" :key="ind">
                        <td class="detail_title_item" colspan="1">
                            {{ item.short_name }}
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item" v-show="showRuleDesc == true">
                    <td class="detail_attr">
                        标准
                        <span id="triangle-up" @click="showRuleDesc = false"></span>
                    </td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div class="detail_val_text" v-html="(item['9'] && item['9']) || '暂无'"></div>
                            </template>

                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <!-- 背景色占位 -->
                </tr>
                <tr class="detail_tr_item" v-show="showRuleDesc == false">
                    <td class="detail_attr">
                        标准
                        <span id="triangle-down" @click="showRuleDesc = true"></span>
                    </td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 5px;
                  " class="detail_val_text" v-html="(item['9'] && item['9']) || '暂无'"></div>
                            </template>
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">
                        <div>得分</div>
                    </td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div class="attr_box">
                                    <!-- <div class="attr_node_name">
                    {{ node_name }}
                  </div> -->
                                    <div class="attr_node_score">
                                        <span class="attr_node_score_num" style="color:#f00">{{ (item["1"] &&
                                            item["1"].item_value_val) ||
                                            0 }}分</span>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">主观评价</td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <div class="detail_val_text" v-html="(item['2'] && item['2'].item_value_val) || '暂无'">
                                </div>
                            </template>
                        </td>
                    </template>
                </tr>
                <!-- <tr class="detail_tr_item">
            <td class="detail_attr">客观信息</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr> -->
                <tr class="detail_tr_item">
                    <td class="detail_attr">图片素材</td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <template v-if="item['4'] && item['4'].ext_info.length > 0">
                                    <div class="detail_val_pic">
                                        <div class="detail_pic_left" @click.stop="
                                            previewImg(item['4'] && item['4'].ext_info, 'img')
                                            ">
                                            <div class="detail_pic_left_img">
                                                <img :src="item['4'].ext_info[0].attach_value || ''" alt="图片加载失败" />
                                                <span class="more_pic">{{
                                                    item["4"] && item["4"].ext_info.length
                                                }}</span>
                                            </div>
                                            <div class="look_pic">点击查看图片</div>
                                        </div>
                                        <div v-if="item['4'] && item['4'].item_value_val"
                                            class="detail_pic_right detail_val_text"
                                            v-html="item['4'] && item['4'].item_value_val"></div>
                                    </div>
                                    <!-- <div class="download_btn"
                                        @click="downloadFn(item['4'] && item['4'].ext_info, model_list[ind].short_name, node_name)">
                                    </div> -->
                                </template>
                                <div class="no_img" v-else>当前测试子节点本次未涉及图片素材</div>
                            </template>
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">视频素材</td>
                    <template v-for="(item, ind) in detail_list" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.has_permission == 1">未开通权限</template>
                            <template v-else>
                                <template v-if="item['5'] && item['5'].ext_info.length > 0">
                                    <div class="detail_val_video">
                                        <div class="detail_video_left" @click.stop="
                                            previewImg(item['5'] && item['5'].ext_info, 'video')
                                            ">
                                            <div class="detail_pic_left_video">
                                                <video controlsList="nodownload"
                                                    :src="item['5'].ext_info[0].attach_value"
                                                    :poster="item['5'].ext_info[0].attach_value + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                                                    preload="none"></video>
                                                <span class="more_pic">{{
                                                    item["5"] && item["5"].ext_info.length
                                                }}</span>
                                            </div>
                                            <div class="look_pic">点击查看视频</div>
                                        </div>
                                        <div class="detail_pic_right detail_val_text"
                                            v-if="item['5'] && item['5'].item_value_val"
                                            v-html="item['5'] && item['5'].item_value_val"></div>
                                    </div>
                                    <!-- <div class="download_btn"
                                        @click="downloadFn(item['5'] && item['5'].ext_info, model_list[ind].short_name, node_name)">
                                    </div> -->
                                </template>
                                <div class="no_img" v-else>当前测试子节点本次未涉及视频素材</div>
                            </template>
                        </td>
                    </template>
                </tr>
            </table>
        </div>
    </el-drawer>
    <el-drawer v-model="dialogCompareVisible2" :title="node_name2" direction="rtl" :before-close="handleClose"
        :size="'auto'" modal-class="modal_transparent">
        <div class="my_dialog" v-if="dialogCompareVisible2">
            <table class="detail_table" border="1">
                <tr class="detail_title">
                    <td class="detail_attr">车型</td>
                    <template v-for="(item, ind) in model_list2" :key="ind">
                        <td class="detail_title_item" colspan="1">
                            {{ item.short_name }}
                        </td>
                    </template>
                </tr>

                <tr class="detail_tr_item">
                    <td class="detail_attr">测评项</td>
                    <template v-for="(item, ind) in detail_list2" :key="ind">
                        <td class="detail_val">
                            <div class="td_score">
                                {{ item.node_name }}
                            </div>
                        </td>
                    </template>
                </tr>

                <tr class="detail_tr_item">
                    <td class="detail_attr">
                        <div>维度评分</div>
                    </td>
                    <template v-for="(item, ind) in detail_list2" :key="ind">
                        <td class="detail_val">
                            <div class="td_score table_text">
                                <p>惊喜：{{ item.surprise_score || 0 }}分</p>
                                <p>实用：{{ item.practical_score || 0 }}分</p>
                                <p>独创：{{ item.originality_score || 0 }}分</p>
                            </div>
                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">
                        <div>综合得分</div>
                    </td>
                    <template v-for="(item, ind) in detail_list2" :key="ind">
                        <td class="detail_val">
                            <div class="attr_box">
                                <div class="attr_node_score">
                                    <span class="attr_node_score_num" style="color:#f00">{{ item.synthetical_score
                                        }}分</span>
                                </div>
                            </div>
                        </td>
                    </template>
                </tr>

                <tr class="detail_tr_item">
                    <td class="detail_attr">图片素材</td>
                    <template v-for="(item, ind) in detail_list2" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.item['3'] && item.item['3'].ext_info.length > 0">
                                <div class="detail_val_pic">
                                    <div class="detail_pic_left" @click.stop="
                                        previewImg(item.item['3'] && item.item['3'].ext_info, 'img')
                                        ">
                                        <div class="detail_pic_left_img">
                                            <img :src="item.item['3'].ext_info[0].attach_value || ''" alt="图片加载失败" />
                                            <span class="more_pic">{{
                                                item.item['3'] && item.item['3'].ext_info.length
                                            }}</span>
                                        </div>
                                        <div class="look_pic">点击查看图片</div>
                                    </div>
                                    <div v-if="item.item['3'] && item.item['3'].item_value_val"
                                        class="detail_pic_right detail_val_text"
                                        v-html="item.item['3'] && item.item['3'].item_value_val"></div>
                                </div>
                                <!-- <div class="download_btn"
                    @click="downloadFn(item.item['3'] && item.item['3'].ext_info, model_list2[ind].short_name, node_name2)">
                  </div> -->
                            </template>
                            <div class="no_img" v-else>当前测试子节点本次未涉及图片素材</div>

                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">视频素材</td>
                    <template v-for="(item, ind) in detail_list2" :key="ind">
                        <td class="detail_val">
                            <template v-if="item.item['4'] && item.item['4'].ext_info.length > 0">
                                <div class="detail_val_video">
                                    <div class="detail_video_left" @click.stop="
                                        previewImg(item.item['4'] && item.item['4'].ext_info, 'video')
                                        ">
                                        <div class="detail_pic_left_video">
                                            <video controlsList="nodownload"
                                                :src="item.item['4'].ext_info[0].attach_value"
                                                :poster="item.item['4'].ext_info[0].attach_value + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                                                preload="none"></video>
                                            <span class="more_pic">{{
                                                item.item['4'] && item.item['4'].ext_info.length
                                            }}</span>
                                        </div>
                                        <div class="look_pic">点击查看视频</div>
                                    </div>
                                    <div class="detail_pic_right detail_val_text"
                                        v-if="item.item['4'] && item.item['4'].item_value_val"
                                        v-html="item.item['4'] && item.item['4'].item_value_val"></div>
                                </div>
                                <!-- <div class="download_btn" 
                    @click="downloadFn(item.item['4'] && item.item['4'].ext_info, model_list2[ind].short_name, node_name2)">
                  </div> -->
                            </template>
                            <div class="no_img" v-else>当前测试子节点本次未涉及视频素材</div>

                        </td>
                    </template>
                </tr>
                <tr class="detail_tr_item">
                    <td class="detail_attr">主观评价</td>
                    <template v-for="(item, ind) in detail_list2" :key="ind">
                        <td class="detail_val">
                            <div class="td_evaluation table_text">
                                <template v-for="(p_item, p_ind) in item.item" :key="p_ind">
                                    <p v-if="
                                        p_item.item_value_val &&
                                        p_item.item_value_type != 4 &&
                                        p_item.item_value_type != 5
                                    " v-html="p_item.item_value_val"></p>
                                </template>
                            </div>
                        </td>
                    </template>
                </tr>


            </table>
        </div>
    </el-drawer>
    <div class="my_swiper_dialog" v-if="swiperVisible">
        <div class="my_swiper_dialog_content">
            <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>
            <swiper :list="preview_list" :type="preview_type" />
        </div>
    </div>
</template>

<script>
import {
    ElDatePicker, ElConfigProvider, ElImage,
    ElTable,
    ElTableColumn,
    ElCheckbox,
    ElCheckboxGroup,
    ElMessage,

    ElDrawer,
} from 'element-plus';
import Swiper from "@/components/swiper/Swiper.vue";
import { useRoute } from 'vue-router';
import {
    getOtaCompareDetail, getOtaCompareDetailContent,
    getSearchResoultV2, getTestDetailV2, getSearchResoultCxV2, getInnovateDetailV2, getOtaKeywordDetail
} from '@/api';
import { ref, computed } from 'vue';
import ECharts from 'vue-echarts';
import 'echarts';
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import store from "@/store";


export default {
    components: {
        'v-chart': ECharts,
        ElDatePicker,
        ElConfigProvider,
        ElImage,
        ElTable,
        ElTableColumn,
        ElCheckbox,
        ElCheckboxGroup,
        Swiper,
        ElDrawer
    },
    setup() {
        const route = useRoute();
        let modelIds = route.query.ids.split(',');
        const function0Option = ref({});
        const function1Option = ref({});
        const function2Option = ref({});
        const step = ref(0);
        const modelList = ref([]);
        const tempStartMonth = ref('');
        const tempEndMonth = ref('');
        const startMonth = ref('');
        const endMonth = ref('');
        const currentFunction0 = ref({});
        const currentFunction1 = ref({});
        const detailData = ref([]);
        const dialogVisible = ref(false);
        const loading = ref(false);
        const loading2 = ref(false);
        const node_list = ref(null);
        const node_list2 = ref(null);
        const dialogCompareVisible = ref(false);
        const node_name = ref('');
        const model_list = ref([]);
        const detail_list = ref([]);
        const node_name2 = ref('');
        const model_list2 = ref([]);
        const detail_list2 = ref([]);
        const dialogCompareVisible2 = ref(false);
        const searchType = ref(0);
        const keywordDetail = ref([]);
        const minDate = ref('');
        const maxDate = ref('');


        const disabledStartDate = (date) => {
            if (!minDate.value || !maxDate.value) {
                return true; // 禁用所有日期，直到 minDate 和 maxDate 被设置
            }
            
            const currentYearMonth = date.getFullYear() * 100 + (date.getMonth() + 1);
            const minYearMonth = parseInt(minDate.value.replace('-', ''));
            const maxYearMonth = parseInt(maxDate.value.replace('-', ''));

            // 先检查日期范围
            if (currentYearMonth < minYearMonth || currentYearMonth > maxYearMonth) {
                return true;
            }

            // 再检查与结束日期的关系
            if (tempEndMonth.value) {
                const selectedEndDate = new Date(tempEndMonth.value);
                return date > selectedEndDate;
            }

            return false;
        };

        const disabledEndDate = (date) => {
            if (!minDate.value || !maxDate.value) {
                return true; // 禁用所有日期，直到 minDate 和 maxDate 被设置
            }
            
            const currentYearMonth = date.getFullYear() * 100 + (date.getMonth() + 1);
            const minYearMonth = parseInt(minDate.value.replace('-', ''));
            const maxYearMonth = parseInt(maxDate.value.replace('-', ''));

            // 先检查日期范围
            if (currentYearMonth < minYearMonth || currentYearMonth > maxYearMonth) {
                return true;
            }

            // 再检查与开始日期的关系
            if (tempStartMonth.value) {
                const selectedStartDate = new Date(tempStartMonth.value);
                return date < selectedStartDate;
            }

            return false;
        };


        const getDetail = async (pid, level) => {
            try {
                const res = await getOtaCompareDetail({
                    model_ids: modelIds,
                    pid: pid,
                    level: level,
                    start_month: startMonth.value,
                    end_month: endMonth.value
                });

                if (minDate.value == '' || maxDate.value == '') {
                    startMonth.value = tempStartMonth.value =  res.data.date_scope.min;
                    endMonth.value = tempEndMonth.value = res.data.date_scope.max;
                    minDate.value = res.data.date_scope.min;
                    maxDate.value = res.data.date_scope.max;
                }

                let dimensions = ['product'];
                let source = [];

                if (level == 0) {
                    modelList.value = res.data.list;
                }

                let series = [];

                const barColor = [
                    { start: '#65BFFF', end: '#ACF9ED' },
                    { start: '#6586FF', end: '#C5ACF9' },
                    { start: '#5DF8D0', end: '#CAF9AC' }
                ]

                res.data.list.forEach((item, index) => {
                    let name = item.brand.name + ' ' + item.name;
                    dimensions.push(name);
                    item.function.forEach((functionItem, index) => {
                        if (source[index] === undefined) {
                            source[index] = { product: functionItem.name, id: functionItem.id, name: functionItem.name };
                        }
                        source[index][name] = functionItem.count;
                    });

                    series.push({
                        type: 'bar',
                        barWidth: 30,
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: barColor[index]['start']
                                }, {
                                    offset: 1, color: barColor[index]['end']
                                }],
                                global: false
                            }
                        },
                    });
                });

                return {
                    legend: {},
                    tooltip: {},
                    dataset: {
                        dimensions: dimensions,
                        source: source
                    },
                    xAxis: { type: 'category' },
                    yAxis: {},
                    series: series
                };

            } catch (error) {
                console.error('Error fetching detail:', error);
                throw error; // rethrow so the caller can handle it or propagate it further
            }
        };

        let function0Id = 0;
        let function1Id = 0;

        const onFunction0ChartClick = (params) => {
            currentFunction0.value = params.data;
            getDetail(params.data.id, 1).then(option => {
                function0Id = params.data.id;
                function1Option.value = option;
            })
            step.value = 1
        }

        const onFunction1ChartClick = (params) => {
            currentFunction1.value = params.data;
            getDetail(params.data.id, 2).then(option => {
                function1Id = params.data.id;
                function2Option.value = option;
            })
            step.value = 2
        }

        const onFunction2ChartClick = (params) => {
            getOtaCompareDetailContent({
                model_ids: modelIds,
                function_2_id: params.data.id,
                start_month: startMonth.value,
                end_month: endMonth.value
            }).then(res => {
                detailData.value = res.data;
                step.value = 3;
            })
        }

        getDetail(0, 0).then(option => {
            function0Option.value = option;
        })

        const search = () => {
            startMonth.value = tempStartMonth.value;
            endMonth.value = tempEndMonth.value;
            research()
        }

        function research() {
            getDetail(0, 0).then(option => {
                function0Option.value = option;
            })
            if (step.value >= 1) {
                getDetail(function0Id, 1).then(option => {
                    function1Option.value = option;
                })
            }
            if (step.value >= 2) {
                getDetail(function1Id, 2).then(option => {
                    function2Option.value = option;
                })
            }
        }

        const handleDeleteClick = (item) => {
            modelIds = modelIds.filter(modelId => String(modelId) != String(item.id));
            store.deleteCompareCarDataOta(item.id);
            research()
        }

        const columnWidth = computed(() => {
            return modelList.value.length > 0 ? `${100 / modelList.value.length}%` : '100%';
        });

        const searchLike = (item, type) => {
            searchType.value = type
            dialogVisible.value = true
            if (type == 1) {
                getOtaKeywordDetail({ tags: item.tags, id: item.id }).then(res => {
                    console.log(res.data.list)
                    keywordDetail.value = res.data.list
                })
            }
            if (type == 2) {
                getSearchResoultV2({
                    keyword: item.item,
                }).then((res) => {
                    console.log('res1', res.data);
                    node_list.value = res.data.map(nodeItem => {
                        return {
                            ...nodeItem,
                            checked_list: []
                        }
                    }) || [];
                    console.log('node_list', node_list);
                    loading.value = false;
                });
            }
            if (type == 3) {
                getSearchResoultCxV2({
                    //keyword: item.tags,
                    keyword: item.tags
                }).then((res) => {
                    console.log('res2', res.data);
                    node_list2.value = res.data.map(item => {
                        return {
                            ...item,
                            checked_list: []
                        }
                    }) || [];
                    loading2.value = false;
                });
            }
        }

        const closeDialog = () => {
            dialogVisible.value = false;
        };

        // getYearData();


        const contrastFn = (row) => {
            let { checked_list, name, node_id } = row;
            node_name.value = name;
            model_list.value = JSON.parse(JSON.stringify(checked_list))
            if (!model_list.value.length) {
                ElMessage.warning("请选择对比车型！");
                return;
            }

            let promise_list2 = model_list.value.map((item) => {
                return new Promise((resolve, reject) => {
                    getTestDetailV2({
                        report_id: item.report_id,
                        model_id: item.model_id,
                        node_id: node_id,
                    })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            });
            Promise.all(promise_list2).then((res_list) => {
                detail_list.value = res_list.map((res) => {
                    let item_value = {
                        has_permission: res.code == 503 ? 1 : 0
                    };
                    if (res.data && res.data.item_value) {
                        res.data.item_value.forEach((item) => {
                            item_value[item.item_value_val_type] = item;
                        });
                        item_value["9"] = res.data["node_desc"];
                    }
                    return item_value;
                });
                dialogCompareVisible.value = true;
            });

        }

        const swiperVisible = ref(false);
        const preview_list = ref([]);
        const preview_type = ref("img");
        const previewImg = (list, type) => {
            console.log(list, type)
            preview_list.value = list;
            preview_type.value = type;
            swiperVisible.value = true;
        };
        const previewVideo = (attachmentList) => {
            // 将 attachment 数组转换为 previewImg 需要的格式
            const videoList = attachmentList.map(item => ({
                attach_value: item.link_url
            }));
            previewImg(videoList, 'video');
        };
        const closeSwiperDialog = () => {
            document.querySelectorAll("video").forEach((item) => {
                item.pause();
            });
            swiperVisible.value = false;
        };
        const objectSpanMethod = ({ row, column, rowIndex, columnIndex }) => {
            if (columnIndex == 2) {
                if (rowIndex == 0) {
                    return {
                        rowspan: node_list2.value.length,
                        colspan: 1,
                        row: row,
                        column: column
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
        }

        const contrastFn2 = () => {
            // let { name } = row;
            console.log('node_list2.value', node_list2.value)
            //node_name2.value = name;
            node_name2.value = '创新项对比'
            // 合并所有的checked_list子数组
            const allCheckedLists = node_list2.value.reduce((acc, item) => {
                return acc.concat(item.checked_list);
            }, []);
            model_list2.value = JSON.parse(JSON.stringify(allCheckedLists));
            if (!model_list2.value.length) {
                ElMessage.warning("请选择对比车型！");
                return;
            }
            let promise_list = allCheckedLists.map(item => {
                return new Promise((resolve, reject) => {
                    getInnovateDetailV2({
                        report_id: item.report_id,
                        model_id: item.model_id,
                        node_ids: item.node_id
                    }).then((res) => {
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    });
                })
            })
            Promise.all(promise_list).then(res_list => {
                detail_list2.value = res_list.map(res_item => {
                    let res_item_data = res_item.data[0];
                    let item_item_val = {};
                    res_item_data.item.forEach(item_item => {
                        item_item_val[item_item.item_value_type] = item_item;
                    })
                    res_item_data.item = item_item_val;
                    return res_item_data;
                })
                dialogCompareVisible2.value = true;
            })

            console.log(model_list2.value, detail_list2.value)

        }

        return {
            function0Option,
            function1Option,
            function2Option,
            onFunction0ChartClick,
            onFunction1ChartClick,
            onFunction2ChartClick,
            step,
            modelList,
            zhCn,
            tempStartMonth,
            tempEndMonth,
            search,
            handleDeleteClick,
            currentFunction0,
            currentFunction1,
            columnWidth,
            detailData,
            detail_list2,
            dialogCompareVisible2,
            model_list2,
            node_name2,
            objectSpanMethod,
            previewImg,
            previewVideo,
            swiperVisible,
            closeSwiperDialog,
            preview_list,
            preview_type,
            dialogCompareVisible,
            contrastFn,
            searchType,
            searchLike,
            dialogVisible,
            keywordDetail,
            closeDialog,
            loading,
            loading2,
            node_list,
            node_name,
            model_list,
            detail_list,
            node_list2,
            contrastFn2,
            disabledStartDate,
            disabledEndDate
        }
    },
}
</script>
<style lang="less" scoped>
:deep(.el-date-editor .el-input__prefix, .el-date-editor .el-input__suffix) {
    display: none;
}

:deep(.el-date-editor .el-input__inner) {
    text-align: center;
    width: 338px;
    height: 30px;
}

:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
    width: 338px;
}

.date-text {
    font-size: 14px;
    color: #191919;
    margin-left: 23px;
    margin-right: 10px;
}

.white_bg {
    padding-top: 28px;
    padding-left: 75px;
}

.l-row {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}

.l-title {
    display: flex;
    align-items: center;
    font-size: 17px;
    color: #404248;
    margin-right: 31px;
}

.l-block {
    width: 6px;
    height: 23px;
    background: #1FBCBF;
    margin-right: 12px;
}

.model-list {
    display: flex;
    align-items: center;
}

.model-item {
    width: 344px;
    height: 23px;
    background: #FAFAFA;
    border-radius: 2px;
    border: 1px solid #D7D7D7;
    margin-right: 19px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.model-name {
    font-size: 14px;
    color: #404E5B;
    padding-left: 23px;
}

.delete-btn {
    width: 20px;
    height: 100%;
    background: url('//img.cy-cdn.com/ceping/delete-btn.png') no-repeat center center;
    background-size: 7px;
    border-left: 1px solid #D7D7D7;
    cursor: pointer;
}

.time-select {
    width: 1070px;
    height: 52px;
    background: #EFF4FA;
    border-radius: 2px;
    margin-right: 75px;
    display: flex;
    align-items: center;
}

.date-btn {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;

    width: 46px;
    height: 30px;
    background: #1FBCBF;
    border-radius: 4px;
    line-height: 30px;
    margin-left: 43px;
    cursor: pointer;
}

.c-title {
    display: flex;
    max-width: 1200px;
    margin-bottom: 40px;
}

.c-title-text {
    font-weight: 600;
    font-size: 17px;
    color: #404248;
    border-bottom: 2px solid #1FBCBF;
    padding: 0 20px;
    padding-bottom: 8px;

}

.c-title-line {
    border-bottom: 1px solid #D4D4D4;
    flex: 1;
}

.fg-line {
    width: 1189px;
    height: 1px;
    border: 1px solid #D4D4D4;
    margin-top: 50px;
    margin-bottom: 30px;
}

.model-table {
    width: 95%;
    margin: 0 auto;
    border-collapse: collapse;
    margin-top: 20px;

    th,
    td {
        border: 1px solid #D7D7D7;
        text-align: center;
        padding: 10px;
        font-size: 14px;
        color: #404E5B;
    }

    th {
        background-color: #F5F5F5;
        font-weight: bold;
    }

    td {
        background-color: #FAFAFA;
        text-align: left;
    }
}

.detail-img {
    max-width: 150px;
}





.like-btn {
    margin-right: 10px;
    color: blue;
    cursor: pointer;
}

.like-btn-list {
    display: flex;
    align-items: center;
}


.custom-dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-dialog {
    background-color: white;
    width: 90%;
    height: 70vh;
    overflow-y: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    position: relative;
}

.custom-dialog-header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #ccc;
}

.close-button {
    background: none;
    border: none;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    transition: color 0.3s;
}

.close-button:hover {
    color: #ff5c5c;
}

.custom-dialog-content {
    padding: 20px;
}

.table_container {
    width: 1130px;
    margin: 20px auto;
}

.node_name {
    padding: 0 10px;
    font-size: 16px;
    color: #555;
    font-weight: 900;
}

.path_names {
    padding: 0 10px;
    font-size: 12px;
    white-space: pre-wrap;
}

.model_list {
    flex-wrap: wrap;

    .model_name {
        flex-grow: 0;
        width: 200px;
        margin: 0;
    }
}

.contrast_btn {
    color: #709ae8;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: pointer;
}

:deep(.modal_transparent) {
    background: transparent;
}

.detail_table .detail_tr_item .detail_val>div.detail_val_text {
    padding: 16px 17px;
    white-space: pre-line;
}

.no_img {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #777c89;
}

.detail_val_pic {
    display: flex;
    align-items: center;

    .detail_pic_left {
        width: 73px;
        height: 80px;
        cursor: pointer;

        .detail_pic_left_img {
            width: 73px;
            height: 60px;
            position: relative;

            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }

            .more_pic {
                width: 20px;
                height: 25px;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
                list-style: 25px;
                font-size: 13px;
                font-weight: bold;
                color: #ffffff;
            }
        }
    }

    .detail_pic_right {
        font-size: 12px;
        font-weight: bold;
        color: #777c89;
        line-height: 16px;
    }
}

.detail_val_video {
    display: flex;
    align-items: center;

    .detail_video_left {
        width: 92px;
        height: 84px;
        cursor: pointer;

        .detail_pic_left_video {
            width: 92px;
            height: 64px;
            position: relative;

            video {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }

            .more_pic {
                width: 20px;
                height: 25px;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
                list-style: 25px;
                font-size: 13px;
                font-weight: bold;
                color: #ffffff;
            }
        }

        .look_pic {
            width: 100%;
            height: 16px;
            font-size: 12px;
            color: #5287ea;
            line-height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.look_pic {
    width: 100%;
    height: 16px;
    font-size: 12px;
    color: #5287ea;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.my_swiper_dialog {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5000;

    .my_swiper_dialog_content {
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .my_swiper_dialog_close {
            width: 50px;
            height: 50px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png) no-repeat center center;
            background-size: 50px 50px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 40px;
            position: absolute;
            top: 40px;
            right: 40px;
            z-index: 2;
            cursor: pointer;
        }
    }
}

.my_dialog {
    width: auto;
    height: auto;
    background: #fff;
    border-radius: 15px;
    padding: 10px;
    max-width: 90vw;
    height: calc(100vh - 75px);
    overflow-x: auto;
    overflow-y: auto;
    z-index: 99;
}

.detail-list {
    max-width: 1080px;
}

.detail-item {
    // margin-bottom: 25px;
}

.detail-content {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #404248;
    font-style: normal;
    margin-top: 12px;
}

.detail-img {
    margin-top: 16px;
    height: 140px;
    margin-right: 25px;
}

.detail-video-wrapper {
    margin-top: 16px;
    margin-right: 25px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    .detail-video-thumb {
        width: 140px;
        height: 140px;
        position: relative;
        overflow: hidden;
        border-radius: 4px;

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .look_pic {
        margin-top: 8px;
        font-size: 12px;
        color: #5287ea;
        line-height: 16px;
    }
}

.detail-item-main {
    display: flex;
}

.detail-item-title {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #000000;
    line-height: 19px;
    font-style: normal;
    display: flex;
    align-items: center;
}

.child-1 {
    margin-top: 54px;
}

.c-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 17px;
    color: #404248;
    line-height: 24px;
    font-style: normal;
}

.c-title-line {
    display: flex;
    margin-top: 10px;
}

.line-1 {
    width: 20px;
    height: 2px;
    background: #1FBCBF;
}

.line-2 {
    width: 59px;
    height: 2px;
    background: #DCDCDC;
}


.mt-10 {
    margin-top: 30px;
}

.mt-50 {
    margin-top: 50px;
}

.sp-line {
    height: 1px;
    width: 100%;
    background: #d0d0d0;
    margin: 20px 0;
    opacity: 0.5;
}

.detail-item-model {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #8b909d;
    font-style: normal;
    margin-top: 10px;
    width: 600px;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}

</style>